<template>
    <div class="file-off-container">
        <div v-if="isHorizont">
            <div>
                <img :src="options.preview_1" class="horizont-image"/>
            </div>
            <div class="row inline justify-center items-center"> 
                <div class="file-count text-negative on-left">
                    <span v-if="!editMode">{{fileOff.count}} из {{options.number}}</span>
                    <span v-if="editMode">
                        <q-input 
                            style="width:50px" 
                            v-model="countValue" 
                            autofocus
                            type='number' 
                            :step='1' 
                            :min='0' 
                            :max='fileOff.order.number' 
                            align='center' 
                            @blur="saveEditFileOff"
                            @keydown="checkKey"
                        />
                    </span>
                </div>
                <q-btn round size='sm' color='primary' icon='settings'>
                     <q-popover ref="popover" class="transparent no-shadow" >
                         <div class='action-container-b'><q-btn round icon="delete_outline" color='negative' size='sm' @click='deleteFileOff'/></div>
                         <div class='action-container-b'><q-btn round icon="edit" color='primary' size='sm' @click='editFileOff'/></div>
                         
                     </q-popover>
                </q-btn>
            </div>
        </div>
        <div v-if="!isHorizont" class='row justify-around'>
            <div style="float:left;">
                <img :src="options.preview_1" class="vertical-image"/>
            </div>
            <div class="vertical-middle" style="padding-top:20px;"> 
                <div class="file-count text-negative" style="margin-bottom:5px;">
                    <div v-if="!editMode">{{fileOff.count}} из {{options.number}}</div>
                    <div v-if="editMode" style="width:100%;">
                        <q-input 
                            style="width:60px" 
                            v-model="countValue" 
                            autofocus
                            type='number' 
                            :step='1' 
                            :min='0' 
                            :max='fileOff.order.number' 
                            align='center' 
                            @blur="saveEditFileOff"
                            @keydown="checkKey"
                        />
                    </div>
                </div>
                <q-btn round size='sm' color='primary' icon='settings'>
                     <q-popover ref="popover" class="transparent no-shadow" >
                         <div class='action-container-b'><q-btn round icon="delete_outline" color='negative' size='sm' @click='deleteFileOff'/></div>
                         <div class='action-container-b'><q-btn round icon="edit" color='primary' size='sm' @click='editFileOff'/></div>
                     </q-popover>
                </q-btn>
            </div>
        </div>

    </div>
</template>

<script>
/* eslint-disable */
export default {

    name : "printTerminalWriteOffFile",

    props : {
        fileOff : {
            type : Object,
            required : true,
        },
    },
    
    data () {
        return {
            editMode : false,
            countValue : 0,
            options : null,
        }
    },
    created() {
        // console.log(this.fileOff)
       
        this.options = JSON.parse(this.fileOff.order.options);
    },
    computed : {
        isHorizont() { // определяем горизонтальная картинка или вертикальная
            console.log('определяемся')
            console.log(this.$refs);
            return this.options.width>=this.options.height;
        }
    },

    methods :{
        imgLoaded() {
            console.log('картинка загружена')
        },
        checkKey(key) {
            if (key.key == 'Enter') this.saveEditFileOff();
            if (key.key == "Escape") this.cancelEditFileOff();
        },

        editFileOff() {
            this.$refs.popover.hide();
            this.countValue = this.fileOff.count;
            this.editMode = true;
        },

        saveEditFileOff() {
            this.editMode = false;
            if (this.countValue>this.fileOff.order.number) {
                this.countValue = this.fileOff.order.number;
            }
            this.$store.commit('changeCountFileOff', {count:this.countValue, order:this.fileOff.order});
        },
        
        cancelEditFileOff() {
            this.editMode = false;
        },
        
        deleteFileOff() {
            this.$refs.popover.hide();
            this.$store.commit('deleteFileOff', this.fileOff.order.id);
        },

    }
    
}
</script>

<style lang="scss" scoped>
    .file-off-container{
        min-width : 150px;
        min-height : 100px;
        background: rgb(233, 233, 233);
        border : 1px solid gray;
        margin: 2px;
        float: left;
        text-align: center;
       
    }
    .horizont-image {
        max-width:100px;
        max-height:80px;
        border : 1px solid gray;
        margin: 3px;
    }
   .vertical-image {
        max-height:80px;
        max-width:100px;
        border : 1px solid gray;
        margin: 3px;
        float : left;
    }
    .file-count{
        font-size: 20px;
        font-weight: bold;
    }
    .action-container-b {
        margin-bottom : 10px;
        margin-top : 10px;
    }
    .action-container {
        background: rgba(255, 255, 255, 0);
    }

</style>


